namespace TabAurous.Finance {
    export interface PDCPayableRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        CreatedBy?: string;
        PartyId?: number;
        LedgerName?: string;
        Amount?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Status?: string;
        Narration?: string;
        BankId?: number;
        VoucherTypeId?: number;
        FinancialYearId?: number;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        CompanyId?: number;
        KnockOffTotal?: number;
        PartyBalance?: PartyBalanceRow[];
    }

    export namespace PDCPayableRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.PDCPayable';
        export const deletePermission = 'Finance:PDCPayable:Delete';
        export const insertPermission = 'Finance:PDCPayable:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:PDCPayable:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            CreatedBy = "CreatedBy",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Status = "Status",
            Narration = "Narration",
            BankId = "BankId",
            VoucherTypeId = "VoucherTypeId",
            FinancialYearId = "FinancialYearId",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            CompanyId = "CompanyId",
            KnockOffTotal = "KnockOffTotal",
            PartyBalance = "PartyBalance"
        }
    }
}
